/**
 * Per-mission media config for Lemonade Leaders Jr.
 *
 * Paste an embeddable video URL (YouTube `embed` URL, Vimeo embed URL,
 * Mux player URL, etc.) when the video for that mission is ready.
 * Leave a slot empty/null to render no video at all on functional missions,
 * or a clean "Video coming soon" placeholder on preview stubs.
 *
 * Example when ready:
 *   1: { url: "https://www.youtube.com/embed/abc123", title: "Welcome to CEO City" },
 */
export const JR_MISSION_VIDEOS = {
  1: { url: null, title: "Welcome to CEO City" },
  2: { url: null, title: "Meet the Biz Birds" },
  3: { url: null, title: "Find a Problem" },
  4: { url: null, title: "Create Your Big Idea" },
  5: { url: null, title: "Brand Your Business" },
  6: { url: null, title: "Money Mission" },
  7: { url: null, title: "Tell the World" },
  8: { url: null, title: "Pitch Day" },
  9: { url: null, title: "Junior CEO Certificate" },
};

export function getMissionVideo(n) {
  return JR_MISSION_VIDEOS[n] || null;
}
